import 'zone.js';
import process from 'process';

declare global {
}

window.process = process;